import React, { useEffect } from "react";
import { gsap } from "gsap";

export default function Blinky() {
  const tl = React.useRef(
    gsap.timeline({ repeat: -1, repeatDelay: 2, yoyo: true })
  );

  useEffect(() => {
    gsap.set("#LeftEar", {
      transformOrigin: "50% 80%",
    });
    gsap.set("#RightEar", {
      transformOrigin: "50% 80%",
    });

    tl.current.from("#Head, #Body", {
      duration: 1,
      y: 250,
      ease: "Back.easeInOut",
    });
    tl.current.to("#Eyes, #Pupils", {
      duration: 0.07,
      scaleY: 0.01,
      transformOrigin: "50% 70%",
      ease: "Sine.easeOut",
    });
    tl.current.to("#Eyes, #Pupils", {
      duration: 0.07,
      scaleY: 1,
      transformOrigin: "50% 70%",
      ease: "Sine.easeOut",
    });
    tl.current.to(
      "#Eyes, #Pupils",
      {
        duration: 0.07,
        scaleY: 0.01,
        transformOrigin: "50% 70%",
        ease: "Sine.easeOut",
      },
      "+=.5"
    );
    tl.current.to("#Eyes, #Pupils", {
      duration: 0.07,
      scaleY: 1,
      transformOrigin: "50% 70%",
      ease: "Sine.easeOut",
    });
    tl.current.to(
      "#Head",
      {
        duration: 0.5,
        rotation: -8,
        transformOrigin: "50% 70%",
        ease: "Sine.easeInOut",
      },
      "+=1"
    );
    tl.current.addLabel("earStart");
    tl.current.to(
      "#LeftEar",

      {
        duration: 0.2,
        rotation: -8,
        ease: "Sine.easeInOut",
      },
      "earStart"
    );
    tl.current.to(
      "#RightEar",

      {
        duration: 0.2,
        rotation: 8,
        ease: "Sine.easeInOut",
      },
      "earStart"
    );
    tl.current.addLabel("earStart2");
    // tl.current.to(
    //   "#LeftEar",

    //   {
    //     duration: 0.2,
    //     rotation: 8,
    //     ease: "Sine.easeInOut",
    //   },
    //   "earStart2"
    // );
    // tl.current.to(
    //   "#RightEar",

    //   {
    //     duration: 0.2,
    //     rotation: -8,
    //     ease: "Sine.easeInOut",
    //   },
    //   "earStart2"
    // );
  }, []);

  return (
    <div id="blinky">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -20 363.36 400.72">
        <g id="Body">
          <path
            d="M513.5,1048.15c-14.63-47.67,2.71-109.62,20-142.89,42.15-81.08,132-84,180-8,21.35,33.83,45.53,100.89,31,150.92C715.91,1146.6,545.34,1151.93,513.5,1048.15Z"
            transform="translate(-433.62 -594.78)"
            fill="#1a1a1a"
            stroke="#000"
            stroke-miterlimit="10"
          />
        </g>
        <g id="Head">
          <path
            d="M455.45,787.69"
            transform="translate(-433.62 -594.78)"
            fill="#fff"
            stroke="#000"
            stroke-miterlimit="10"
          />
          <g>
            <path
              d="M629.06,929.5c-15,0-30.47-4.21-48.43-9.09a321,321,0,0,1-59.91-22.92c-21.08-5.94-50.05-18.07-68.82-42.37-49.27-63.75,19.05-148.82,22-152.41,30.43-37.25,72.58-61,118.67-67a188.44,188.44,0,0,1,24-1.52,183,183,0,0,1,57.79,9.15c47.18,15.67,70.71,46.2,84.76,64.44C777.36,731.49,805,767.3,794,808.54c-7.28,27.45-28.66,46-45.85,61-14.2,12.34-30.48,21.55-62.92,39.9-26.82,15.18-34.37,17.43-40.84,18.65A81.32,81.32,0,0,1,629.06,929.5Z"
              transform="translate(-433.62 -594.78)"
            />
            <path
              d="M616.56,634.71a182.55,182.55,0,0,1,57.62,9.12c47,15.63,70.51,46.08,84.53,64.28,18.19,23.61,45.69,59.3,34.82,100.3-7.23,27.3-28.55,45.83-45.69,60.72-14.16,12.3-30.42,21.5-62.83,39.84-26.76,15.14-34.26,17.38-40.7,18.59A81.09,81.09,0,0,1,629.06,929c-14.18,0-27.59-3.45-48.3-9.07A320,320,0,0,1,521,897l-.09,0-.09,0c-20.92-5.88-49.79-18-68.48-42.15-49-63.45,19.06-148.21,22-151.79,30.36-37.16,72.39-60.88,118.36-66.81a189.11,189.11,0,0,1,23.93-1.51h0m0-1a188,188,0,0,0-24,1.52c-71.68,9.24-111,57.43-119,67.17-4,4.89-71.07,89.52-22,153,20.16,26.09,51.38,37.55,69,42.51a321,321,0,0,0,60,22.95c19.49,5.3,33.92,9.11,48.56,9.11a81.88,81.88,0,0,0,15.44-1.46c6.34-1.2,13.82-3.33,41-18.7,32.51-18.39,48.76-27.59,63-40,17.06-14.82,38.68-33.62,46-61.21,11-41.48-17-77.79-35-101.17-14.1-18.3-37.68-48.9-85-64.62a184.52,184.52,0,0,0-58-9.17Z"
              transform="translate(-433.62 -594.78)"
            />
          </g>
          <path
            d="M602.5,851.5a20.09,20.09,0,0,0,14,3c10.33-1.82,14.53-11.81,15-13a24.54,24.54,0,0,0,1-13s-1.61,8.81,2,14c3,4.26,12,13,31,4"
            transform="translate(-433.62 -594.78)"
            fill="none"
            stroke="#4d4d4d"
            stroke-miterlimit="10"
            stroke-width="3"
          />
          <path
            d="M613.14,809.41l29.07-3.87a3.54,3.54,0,0,1,.65,0c1.26.08,5.14,1.13,2.64,4-3.88,4.44-9,15-10.75,16.39-1.09.87-2.28,1.57-3.63,1.18a19.21,19.21,0,0,1-6.62-3.57,60.58,60.58,0,0,0-11.68-6.86,3,3,0,0,1-.69-.41c-1.14-.9-4.34-3.86-.36-6.33A3.63,3.63,0,0,1,613.14,809.41Z"
            transform="translate(-433.62 -594.78)"
            fill="#ffecf6"
            stroke="#000"
            stroke-miterlimit="10"
          />
          <path
            d="M759.5,1012.5"
            transform="translate(-433.62 -594.78)"
            fill="#fff"
            stroke="#000"
            stroke-miterlimit="10"
          />
          <g id="Eyes">
            <path
              d="M511.5,749.5c-.76-9.74,13.55-19.54,20-23a43.85,43.85,0,0,1,24-5c3.66.29,13.75,1.07,22,8,13,11,17.17,33.66,9,43-2,2.25-27.38,18.09-46.42,12C522.81,779,511.67,751.7,511.5,749.5Z"
              transform="translate(-433.62 -594.78)"
              fill="#3fdd8c"
              stroke="#000"
              stroke-miterlimit="10"
            />
            <path
              d="M729.94,746.74c.76-9.74-13.55-19.54-20-23a43.85,43.85,0,0,0-24-5c-3.66.29-13.75,1.07-22,8-13,11-17.17,33.66-9,43,2,2.25,27.38,18.09,46.42,12C718.63,776.23,729.77,748.94,729.94,746.74Z"
              transform="translate(-433.62 -594.78)"
              fill="#3fdd8c"
              stroke="#000"
              stroke-miterlimit="10"
            />
          </g>
          <g id="Pupils">
            <circle
              cx="131.38"
              cy="166.22"
              r="24.5"
              stroke="#000"
              stroke-miterlimit="10"
            />
            <circle
              cx="260.38"
              cy="166.22"
              r="24.5"
              stroke="#000"
              stroke-miterlimit="10"
            />
            <g>
              <path
                d="M576.8,755.2c-.85,0-2.65-.93-6-3.12-6.84-4.43-7.8-6-7.77-6.55.12-2,3.33-3.42,3.69-3.57a7,7,0,0,1,2.69-.53,9.12,9.12,0,0,1,3,.54,8.52,8.52,0,0,1,4.72,3.78c1.1,1.93,1,3.77.94,5.73s-.13,3.19-.77,3.6A.77.77,0,0,1,576.8,755.2Z"
                transform="translate(-433.62 -594.78)"
                fill="#fff"
              />
              <path
                d="M569.38,741.93h0a8.41,8.41,0,0,1,2.8.52,8,8,0,0,1,4.45,3.54c1,1.81,1,3.5.87,5.47-.07,1.57-.12,2.93-.54,3.2a.28.28,0,0,1-.16,0c-.95,0-3.74-1.74-5.76-3-7.53-4.87-7.54-6-7.54-6.1.08-1.4,2.17-2.63,3.38-3.14a6.63,6.63,0,0,1,2.5-.49m0-1a7.55,7.55,0,0,0-2.88.57c-.44.18-3.86,1.66-4,4,0,.54.07,1.86,8,7,3.74,2.42,5.37,3.2,6.3,3.2a1.26,1.26,0,0,0,.7-.2c.86-.55.91-1.87,1-4s.17-4-1-6a9.08,9.08,0,0,0-5-4,9.39,9.39,0,0,0-3.12-.57Z"
                transform="translate(-433.62 -594.78)"
              />
            </g>
            <g>
              <path
                d="M708.65,757c-.85,0-2.65-.93-6-3.12-6.84-4.43-7.81-6-7.77-6.55.12-2,3.32-3.42,3.69-3.57a7,7,0,0,1,2.69-.53,9.18,9.18,0,0,1,3,.54,8.56,8.56,0,0,1,4.72,3.78c1.1,1.93,1,3.69.94,5.73s-.14,3.19-.77,3.6A.77.77,0,0,1,708.65,757Z"
                transform="translate(-433.62 -594.78)"
                fill="#fff"
              />
              <path
                d="M701.23,743.77h0a8.47,8.47,0,0,1,2.8.52,8,8,0,0,1,4.45,3.54c1,1.81.95,3.5.87,5.47-.07,1.57-.12,2.93-.54,3.2a.28.28,0,0,1-.16,0c-1,0-3.74-1.73-5.76-3-7.53-4.87-7.55-6-7.54-6.1.08-1.4,2.16-2.63,3.38-3.14a6.63,6.63,0,0,1,2.5-.49m0-1a7.52,7.52,0,0,0-2.88.57c-.44.18-3.86,1.66-4,4,0,.54.06,1.87,8,7,3.74,2.42,5.37,3.2,6.3,3.2a1.31,1.31,0,0,0,.7-.2c.85-.55.91-1.87,1-4s.16-4-1-6a9.15,9.15,0,0,0-5-4,9.5,9.5,0,0,0-3.12-.57Z"
                transform="translate(-433.62 -594.78)"
              />
            </g>
          </g>
          <g id="Ears">
            <g id="RightEar">
              <path
                d="M759.94,710.8c7.62-5.17,6.75-24.45,5-63-2.15-47.5-8.58-51.12-11-52-7.12-2.59-17.74,6.27-39,24-11.64,9.71-15.05,14.32-27,22-10.93,7-13.8,6.84-15,10C666.21,669.55,737.43,726.08,759.94,710.8Z"
                transform="translate(-433.62 -594.78)"
                stroke="#000"
                stroke-miterlimit="10"
              />
              <path
                d="M754.6,706.89c6.64-4.51,5.88-21.32,4.36-54.94-1.88-41.42-7.48-44.57-9.6-45.34-6.2-2.26-15.47,5.47-34,20.93C705.2,636,702.23,640,691.81,646.72c-9.53,6.12-12,6-13.08,8.72C672.85,670.92,735,720.22,754.6,706.89Z"
                transform="translate(-433.62 -594.78)"
                fill="#ffecf6"
                stroke="#000"
                stroke-miterlimit="10"
              />
            </g>
            <g id="LeftEar">
              <path
                d="M470.7,710.72c-7.62-5.17-6.75-24.45-5-63,2.15-47.5,8.58-51.12,11-52,7.12-2.59,17.75,6.27,39,24,11.64,9.71,15,14.32,27,22,10.93,7,13.8,6.84,15,10C564.44,669.47,493.21,726,470.7,710.72Z"
                transform="translate(-433.62 -594.78)"
                stroke="#000"
                stroke-miterlimit="10"
              />
              <path
                d="M475.94,706.77c-6.65-4.51-5.89-21.32-4.36-54.94,1.87-41.42,7.48-44.57,9.59-45.34,6.21-2.26,15.47,5.47,34,20.93,10.15,8.46,13.12,12.49,23.55,19.18,9.52,6.12,12,6,13.08,8.72C557.68,670.8,495.57,720.1,475.94,706.77Z"
                transform="translate(-433.62 -594.78)"
                fill="#ffecf6"
                stroke="#000"
                stroke-miterlimit="10"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}
